import React from 'react';

function About({ darkMode }) {
  return (
    <main className="main-content" style={{ height: '100vh', overflowY: 'auto', paddingBottom: '40px' }}>
      <div className="main-content-header" style={{ position: 'sticky', top: '20px', zIndex: 10, backgroundColor: '#1cb0f6', borderBottom: '4px solid #148ac2', borderRadius: '16px', color: 'white', marginBottom: '20px', marginTop: '20px' }}>
        <h2>Über uns</h2>
        <span>Unsere Mission</span>
      </div>

      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 20px', textAlign: 'center' }}>
        
        <div style={{ fontSize: '60px', marginBottom: '5px', animation: 'float 3s ease-in-out infinite' }}>🚀</div>
        
        <h1 style={{ fontSize: '2rem', fontWeight: '900', marginBottom: '15px', color: darkMode ? '#fff' : '#3c3c3c' }}>
          Lerne Coden. <br/> <span style={{ color: '#1cb0f6' }}>Verändere die Welt.</span>
        </h1>

        <div style={{ 
          backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.5)' : 'rgba(255, 255, 255, 0.5)', 
          backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)',
          padding: '20px', 
          borderRadius: '20px', 
          border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
          boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
          maxWidth: '600px', 
          margin: '0 auto 30px auto',
          animation: 'pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0s both'
        }}>
          <p style={{ fontSize: '1.1rem', lineHeight: '1.5', color: darkMode ? '#ccc' : '#777', margin: 0, fontWeight: '700' }}>
            Wir glauben, dass jeder programmieren lernen kann. Mit Duocode machen wir es einfach, spaßig und für alle zugänglich. Keine langweiligen Vorlesungen, nur interaktive Praxis.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '15px', marginBottom: '30px' }}>
          <div style={{ 
            backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.5)' : 'rgba(255, 255, 255, 0.5)', 
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            padding: '20px', 
            borderRadius: '20px', 
            border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
            boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            transition: 'transform 0.2s',
            cursor: 'default',
            animation: 'pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.1s both'
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <div style={{ backgroundColor: 'rgba(255, 75, 75, 0.1)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>
                ❤️
            </div>
            <h3 style={{ margin: 0, fontSize: '1.1rem', color: darkMode ? '#fff' : '#3c3c3c' }}>Mit Liebe gemacht</h3>
            <p style={{ margin: 0, color: darkMode ? '#aaa' : '#777', fontSize: '0.9rem', lineHeight: '1.4' }}>Entwickelt von Codern für Coder. Wir wissen, wie schwer der Anfang ist.</p>
          </div>

          <div style={{ 
            backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.5)' : 'rgba(255, 255, 255, 0.5)', 
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            padding: '20px', 
            borderRadius: '20px', 
            border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
            boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            transition: 'transform 0.2s',
            cursor: 'default',
            animation: 'pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.2s both'
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <div style={{ backgroundColor: 'rgba(255, 200, 0, 0.1)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>
                ⚡
            </div>
            <h3 style={{ margin: 0, fontSize: '1.1rem', color: darkMode ? '#fff' : '#3c3c3c' }}>Gamified Learning</h3>
            <p style={{ margin: 0, color: darkMode ? '#aaa' : '#777', fontSize: '0.9rem', lineHeight: '1.4' }}>Sammle XP und steige Level auf. Lernen fühlt sich an wie ein Spiel.</p>
          </div>

          <div style={{ 
            backgroundColor: darkMode ? 'rgba(43, 43, 43, 0.5)' : 'rgba(255, 255, 255, 0.5)', 
            backdropFilter: 'blur(10px)',
            WebkitBackdropFilter: 'blur(10px)',
            padding: '20px', 
            borderRadius: '20px', 
            border: darkMode ? '2px solid #444' : '2px solid #e5e5e5',
            boxShadow: '0 4px 0 rgba(0,0,0,0.05)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            transition: 'transform 0.2s',
            cursor: 'default',
            animation: 'pop-up 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.3s both'
          }}
          onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
          >
            <div style={{ backgroundColor: 'rgba(88, 204, 2, 0.1)', width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '24px' }}>
                🌍
            </div>
            <h3 style={{ margin: '0', fontSize: '1.1rem', color: darkMode ? '#fff' : '#3c3c3c' }}>Für Alle</h3>
            <p style={{ margin: 0, color: darkMode ? '#aaa' : '#777', fontSize: '0.9rem', lineHeight: '1.4' }}>Egal woher du kommst oder wie alt du bist. Bildung sollte frei und für jeden zugänglich sein.</p>
          </div>
        </div>

        <div style={{ color: darkMode ? '#555' : '#ccc', fontSize: '0.85rem', fontWeight: 'bold' }}>
            © 2026 Duocode
        </div>

      </div>
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        @keyframes pop-up {
          0% { transform: scale(0.95); opacity: 0; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </main>
  );
}

export default About;
